<template>
    <div id="PatientClaimList">
    <div class="row">
      <div class="col-12">
        <MdTitleRegInfo
            v-bind:RegistrationInfo="PatientTitle"
            v-bind:titlePrefix="$tc('PatientClaimList.PatientClaimTitle',2)"
            v-bind:IsClinical="false"
            v-bind:titleRef="'titleElementPatientClaimList'"
            v-bind:patientCode="this.$route.params.id">
        </MdTitleRegInfo>

        <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
               <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
               <div class="flex-grow-1">
                 <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
               </div>
             </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <MdButton
                      v-bind:Label="$t('PatientClaimList.AddClaim')"
                      v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                      v-bind:IconClass="'ti-plus pr-1'"
                      v-on:click="AddClaim"
                      v-bind:isReadOnly="isReadOnly"
                      v-bind:Name="'btn_add_contact'">
                    </MdButton>
                </div>
                <b-col lg="2" md="2" sm="12">
                <MdDateTime
                  :Label="$t('Shared.datefrom')"
                  :Model="DateFrom"
                  @input="DateFrom = $event"
                  :Id="'PatientClaimListDateFrom'"
                  :Type="'date'"
                  :OnPressEnter="SearchClaim"
                  :isRequired="false"
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>
        </b-col>
        <b-col lg="2" md="2" sm="12">
                <MdDateTime
                  :Label="$t('Shared.dateTo')"
                  :Model="DateTo"
                  @input="DateTo = $event"
                  :Id="'PatientClaimListDateTo'"
                  :Type="'date'"
                  :OnPressEnter="SearchClaim"
                  :isRequired="false"
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>
        </b-col>
         <b-col lg="2" md="2" sm="12">
            <MdSelect
                v-bind:Label="'Filter'"
                v-bind:Options="ListStatus"
                v-bind:Model="status"
                v-bind:AllowEmpty="true"
                v-bind:Multiple="true"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                :Input="ChangeStatus"/>
        </b-col>
         <b-col lg="3" md="3" sm="12">
           <button
					type="button"
                    v-on:click="SearchClaim"
					class="btn btn-primary btn-login mt-3"
					id="btnsearchinput">
					{{ $t('Shared.Search') }}
				</button>
        </b-col>

            </div>
        </div>
    </div>

    <b-row>

    </b-row>

     <MdTitle v-bind:Text="this.$t('Shared.SearchResult')+' - '+this.$t('PatientClaimList.AmtBilled')+' $'+AmtBilled+ ' - '+this.$t('PatientClaimList.AmtPaid')+' $'+AmtPaid+ ' - '+this.$t('PatientClaimList.Balance')+' $'+Balance+ ' - '+this.$t('PatientClaimList.Credit')+' $'+Credit" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
    <b-row>
     <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll"
                  v-on:change="onChangeSelectAll"
               />
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('claimbatchList.selected') }}</span>
              </div>
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group" dir="ltr">
                          <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="Criteria"
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="FindinItems()"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
            </b-row>

            <BaseModal
                :ModalId="'ModalIdWarningClaimVoid'"
                v-if="WarningVisible"
                :TitleWindow="`Warning`"
                :width="'30%'"
                :height="'auto'"
                :HideModalFun="CancelClick"
                @Close="CancelClick"
                :buttons="[
                    { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                    { text: $t('Shared.TitleOK'), variant: 'primary', action: OkClick },
                ]">

                <div v-html="Message"></div>

            </BaseModal>


            <BaseModal
                :ModalId="'ModalIdHistoryClaim'"
                v-if="ClaimHistoryVisible"
                :TitleWindow="$t('claimbatchList.History')"
                :width="'60%'"
                :height="'auto'"
                :HideModalFun="CancelHistoryClick"
                @Close="CancelHistoryClick"
                :buttons="[
                    { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' },
                ]">

                 <MdTable
                        v-bind:fields="fieldsHistory"
                        v-bind:items="ItemsHistory"
                        v-bind:totalRows="totalRowsHistory"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyHistory"
                        v-bind:currentPage="currentPageHistory"
                        v-bind:perPage="perPageHistory"
                         v-bind:FieldsDate="FieldsDateHistoryArr"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'PatientClaimHistory'"
                        :onRowSelected="onRowSelectedHistory"
                        :onFiltered="onFilteredHistory"
                        :pageChanged="pageChangedHistory"
                        :perPageFunction="PerPageFunctionHistory">
                      </MdTable>

            </BaseModal>


            <BaseModal
                :ModalId="'ModalIdClaimAttendanceRecords'"
                v-if="ClaimAttendanceRecordsVisible"
                :TitleWindow="$t('PatientClaimList.AttendanceRecords')"
                :width="'75%'"
                :height="'auto'"
                :HideModalFun="CancelAttendanceRecordsClick"
                @Close="CancelAttendanceRecordsClick"
                :buttons="[
                    { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                    { text: $t('Shared.Undo'), variant: 'primary', action: AttendanceRecordUndoClick },
                ]">

                  <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('PatientClaimList.AttendanceOption')"
                            v-bind:Options="AttendanceOptionList"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Attendance"
                            v-bind:Multiple="false"
                            v-bind:IsDisabled="false"
                            :Input="ChangeDropDownAttendanceOption"/>
                     </b-col>
                  </b-row>

                <b-row>
     <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAllDetail'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.ItemsDetail.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableDetailAll"
                  v-on:change="onChangeSelectDetailAll"
               />
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ DetailSelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="DetailSelectedRecords != 1">s</span> {{ $t('claimbatchList.selected') }}</span>
              </div>
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group" dir="ltr">
                          <input
                            type="text"
                            class="form-control"
                            id="SearchDetailAttendance"
                            :dir="dirInput"
                            v-model="DetailSearchCriteria"
                            @keyup.enter="FindinDetailItems()"
                          >
                          <div class="input-group-append">
                              <MdButton
                                v-bind:Name="'btnsearchClaimDetailinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="FindinDetailItems()"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
            </b-row>

                 <MdTablePaginationClient
                        v-bind:fields="fieldsDetail"
                        v-bind:items="ItemsDetail"
                        v-bind:totalRows="totalRowsDetail"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyDetail"
                        v-bind:currentPage="currentPageDetail"
                        v-bind:perPage="perPageDetail"
                        v-bind:pageOptions="pageOptions"
                        v-bind:FieldsDate="FieldsDateDetailArr"
                        v-bind:refTable="'PatientClaimDetail'"
                        :onRowSelected="onRowSelectedDetail"
                        :onFiltered="onFilteredDetail"
                        :pageChanged="pageChangedDetail"
                        :RowClick="rowClickHandlerDetail"
                        :perPageFunction="PerPageFunctionDetail">
                      </MdTablePaginationClient>

            </BaseModal>

    <MdTablePaginationClient
        v-bind:fields="fields"
        v-bind:items="items"
        v-bind:totalRows="totalRows"
        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
        v-bind:currentPage="currentPage"
        v-bind:perPage="perPage"
        v-bind:pageOptions="pageOptions"
        :editIconEvent="EditClaim"
        v-bind:FieldsDate="FieldsDateArr"
        v-bind:VisibleEditIcon="true"
        :onRowSelected="onRowSelected"
        :pageChanged="pageChanged"
        v-bind:VisibleVoidIcon="true"
        v-bind:VisibleHistoryIcon="true"
        :HistoryIconEvent="HistoryClick"
        v-bind:TootilViewIcon="$t('PatientClaimList.DETAIL')"
        :perPageFunction="PerPageFunction"
        :RowClick="rowClickHandler"
       >
    </MdTablePaginationClient>

    <MdPasswordDlg v-if="showSignPasswordSuperVisor"
      v-bind:Type="'Sign'"
      v-bind:VerificationType="'SupervisorPassword'"
      @getModalPassword="onModalPasswordResultSuperVisor($event)"
  />


      <div class="space-actions"></div>
      <div class="page-actions">
           <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2" v-if="this.SelectedItem.length > 0">
                <!--<b-dropdown-item  href="#" v-on:click="showReport()">{{$t('schedulerDB.dropdown.Report')}}</b-dropdown-item>-->
                <b-dropdown-item  v-on:click="UpdateAction('sendFlag',false,false)"  href="#"> {{$t('PatientClaimList.1ECSFLAG')}} </b-dropdown-item>
                <b-dropdown-item  v-on:click="UpdateAction('paidFull',false,false)" href="#"> {{$t('PatientClaimList.2PAIDFLAG')}} </b-dropdown-item>
                <b-dropdown-item  v-on:click="UpdateAction('Printflag',true,false)" > {{$t('PatientClaimList.PRINTFLAG')}} </b-dropdown-item>
                <b-dropdown-item  v-on:click="UpdateAction('',true,true)" > {{$t('PatientClaimList.ALLFLAGS')}} </b-dropdown-item>
                <b-dropdown-item  v-on:click="UpdateAction('ShowInPatientPortal',false,false)" > {{$t('PatientClaimList.SHOWINPORTAL')}} </b-dropdown-item>
                <b-dropdown-item v-if="this.SelectedItem.length === 1" v-on:click="DetailClick" href="#"> {{$t('PatientClaimList.DETAIL')}} </b-dropdown-item>
                <b-dropdown-item  v-on:click="VoidClick"> {{ $t('Shared.Void') }}</b-dropdown-item>
                <!--<b-dropdown-item  href="#"> {{$t('Shared.Print')}} </b-dropdown-item>-->
            </b-dropdown>
        </div>


    </div>
</template>

<script>

import EnumService from '@/services/enum.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import Permission from '@/common/Permission'
import ClaimList from '@/services/claimlist.service';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'PatientClaimList',
  mixins: [ShowMessage, DBFunctions, Permission],
  data(){
    return{
        items:[],
        itemsCopy:[],
        ItemsDetailCopy:[],
        Message:"",
        StateClick:"",
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        perPageDetail:10,
        totalRowsHistory:0,
        totalRowsDetail:0,
        currentPage: 1,
        currentPageDetail:1,
        currentPageHistory:1,
        perPage: 10,
        perPageHistory:10,
        WarningVisible:false,
        SelectedRecords:0,
        DetailSelectedRecords:0,
        UseSelectTableAll:false,
        ShowMessageIsEmptyDetail:false,
        UseSelectTableDetailAll:false,
        ItemClicked:{},
        SelectedItem:[],
        DetailSelectedItem:[],
        AttendanceOptionList:EnumService.PatientClaimAttendanceOptions,
        Attendance:0,
        Criteria:"",

        DetailSearchCriteria:"",
        FieldsDateArr:['dateFrom','dateTo','datePaid','sysDate'],
        FieldsDateDetailArr:['transDate','serviceDate'],
        FieldsDateHistoryArr:['sysDate'],
        showSignPasswordSuperVisor:false,
        ClaimHistoryVisible:false,
        ShowMessageIsEmptyHistory:false,
        ClaimAttendanceRecordsVisible:false,
        fieldsHistory:[
            { key: 'groupCreationID', sortable: true, label: this.$t('PatientClaimList.GroupCreationID') , class: 'text-left' },
            { key: 'seqNo', sortable: true, label: this.$t('PatientClaimList.SeqNo'), class: 'text-left' },
            { key: 'patientClaimstatus', sortable: true, label: this.$t('PatientClaimList.Status') , class: 'text-left' },
            { key: 'sysDate', sortable: true, label:this.$t('PatientClaimList.CreatedOn'), class: 'text-left' },
            { key: 'sysUser', sortable: true, label: this.$t('PatientClaimList.CreatedBy'), class: 'text-left' },
            { key: 'paid', sortable: true, label: this.$t('PatientClaimList.Paid'), class: 'text-left' },
            { key: 'denied', sortable: true, label: this.$t('PatientClaimList.Denied'), class: 'text-left' },
            { key: 'adj', sortable: true, label: this.$t('PatientClaimList.Adj') , class: 'text-left' },
            { key: 'deduct', sortable: true, label: this.$t('PatientClaimList.Deduct') , class: 'text-left' },
            { key: 'ref', sortable: true, label: this.$t('PatientClaimList.Ref') , class: 'text-left' },
            { key: 'icn', sortable: true, label: this.$t('PatientClaimList.Icn') , class: 'text-left' },
        ],
        fieldsDetail:[
            { key: 'transDate', sortable: true, label: this.$t('PatientClaimList.TransDate'), class: 'text-left' },
            { key: 'recNo', sortable: true, label: 'RecNo', class: 'text-left hidden' },
            { key: 'serviceDate', sortable: true, label: this.$t('PatientClaimList.ServiceDate'), class: 'text-left' },
            { key: 'courseCode', sortable: true, label: this.$t('PatientClaimList.Therapy'), class: 'text-left' },
            { key: 'therapistCode', sortable: true, label: this.$t('PatientClaimList.Therapist') , class: 'text-left' },
            { key: 'progCode', sortable: true, label: this.$t('PatientClaimList.Program') , class: 'text-left' },
            { key: 'timeFrom', sortable: true, label: this.$t('PatientClaimList.TimeFrom'), class: 'text-left' },
            { key: 'timeTo', sortable: true, label: this.$t('PatientClaimList.TimeTo'), class: 'text-left' },
            { key: 'unit', sortable: true, label: this.$t('PatientClaimList.Unit'), class: 'text-left',formatter: value => { return parseFloat(value).toFixed(0)} },
            { key: 'billSeqNo', sortable: true, label: this.$t('PatientClaimList.SeqNo'), class: 'text-left' },
            { key: 'name', sortable: true, label: this.$t('PatientClaimList.Name') , class: 'text-left' },
        ],

        fields: [
          { key: 'sysDate', sortable: true, label: this.$t('PatientClaimList.CreatedOn') , class: 'text-left' },
          { key: 'fullUserName', sortable: true, label: this.$t('PatientClaimList.CreatedBy'), class: 'text-left' },
          { key: 'issLineNo', sortable: true, label: this.$t('PatientClaimList.IssLineNo'), class: 'text-left'},
          { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-left' },
          { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-left' },
          { key: 'posCode', sortable: true, label: this.$t('PatientClaimList.PosCode'), class: 'text-left' },
          { key: 'cptHcpcs', sortable: true, label: this.$t('PatientClaimList.CptHcpcs'), class: 'text-left' },
          { key: 'hcpcsCode', sortable: true, label: this.$t('PostPayment.HCPCSCode'), class: 'text-left' },
          { key: 'modifier1', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 1 }), class: 'text-left' },
          { key: 'modifier2', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 2 }), class: 'text-left' },
          { key: 'modifier3', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 3 }), class: 'text-left' },
          { key: 'modifier4', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 4 }), class: 'text-left' },
          { key: 'recId', sortable: true, label: this.$t('PatientClaimList.RecId'), class: 'text-right hidden'},
          { key: 'patientCode', sortable: true, label: 'patientCode', class: 'text-left hidden' },
          { key: 'diagCode', sortable: true, label: this.$t('PatientClaimList.DiagCode'), class: 'text-left' },
          { key: 'fullDoctorName', sortable: true, label: this.$t('PatientClaimList.Provider'), class: 'text-left' },
          { key: 'dayUnit', sortable: true, label: this.$t('PatientClaimList.DayUnit'), class: 'text-left' },
          { key: 'charges', sortable: true, label: this.$t('HouseFile.Charges'), class: 'text-left',formatter: value => { return '$'+parseFloat(value).toFixed(2)} },
          { key: 'paid', sortable: true, label: this.$t('PatientClaimList.Paid'), class: 'text-left' },
          { key: 'paidAmt', sortable: true, label: this.$t('PatientClaimList.PaidAmt'), class: 'text-left' },

          { key: 'primaryInsurance', sortable: true, label: this.$t('PatientClaimList.PrimaryInsurance'), class: 'text-left' },
          { key: 'primInsuranceNo', sortable: true, label: this.$t('PatientClaimList.PrimInsuranceNo'), class: 'text-left' },
          { key: 'secondaryInsurance', sortable: true, label: this.$t('PatientClaimList.SecondaryInsurance'), class: 'text-left' },
          { key: 'secInsuranceNo', sortable: true, label: this.$t('PatientClaimList.SecInsuranceNo'), class: 'text-left' },
          { key: 'tertiaryInsurance', sortable: true, label: this.$t('PatientClaimList.TertiaryInsurance'), class: 'text-left' },
          { key: 'terInsuranceNo', sortable: true, label: this.$t('PatientClaimList.TerInsuranceNo'), class: 'text-left' },

          { key: 'valueCode', sortable: true, label: this.$t('Shared.ValueCode'), class: 'text-left' },
          { key: 'conditionCode1', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 1 }), class: 'text-left' },
          { key: 'conditionCode2', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 2 }), class: 'text-left' },
          { key: 'conditionCode3', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 3 }), class: 'text-left' },
          { key: 'conditionCode4', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 4 }), class: 'text-left' },
          { key: 'conditionCode5', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 5 }), class: 'text-left' },
          { key: 'conditionCode6', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 6 }), class: 'text-left' },
          { key: 'conditionCode7', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 7 }), class: 'text-left' },
          { key: 'showInPatientPortal', sortable: true, label: this.$t('ActList.ShowToPatient'), class: 'text-left',formatter: value => { return value ? 'Y' : 'N'} },
          { key: 'sendFlag', sortable: true, label: this.$t('PatientClaimList.SendFlag'), class: 'text-left',formatter: value => { return value ? 'Y' : 'N'}  },
          { key: 'paidFull', sortable: true, label: this.$t('PatientClaimList.PaidFull'), class: 'text-left',formatter: value => { return value ? 'Y' : 'N'} },
          { key: 'printFlag', sortable: true, label: this.$t('PatientClaimList.PrintFlag'), class: 'text-left' },
          { key: 'Amtapproved', sortable: true, label: this.$t('PatientClaimList.Amtapproved'), class: 'text-left' },
          { key: 'tosCode', sortable: true, label: this.$t('PatientClaimList.TosCode'), class: 'text-left' },
          { key: 'unitPrice', sortable: true, label: this.$t('drug.UnitPrice'), class: 'text-left' },
          { key: 'electronic', sortable: true, label: this.$t('PatientClaimList.Electronic'), class: 'text-left' },
          { key: 'repeatDone', sortable: true, label: this.$t('PatientClaimList.RepeatDone'), class: 'text-left' },
          { key: 'masterLineNo', sortable: true, label: this.$t('PatientClaimList.MasterLineNo'), class: 'text-left' },
          { key: 'datePaid', sortable: true, label: this.$t('PatientClaimList.DatePaid'), class: 'text-left' },
          { key: 'generationType', sortable: true, label: this.$t('PatientClaimList.GenerationType'), class: 'text-left' },
          { key: 'chkno', sortable: true, label: this.$t('PatientClaimList.Chkno'), class: 'text-left' },
          { key: 'seqNo', sortable: true, label: this.$t('PatientClaimList.SeqNo'), class: 'text-left' },
          { key: 'diagInd', sortable: true, label: this.$t('PatientClaimList.DiagInd'), class: 'text-left' },
          { key: 'docInd', sortable: true, label: this.$t('PatientClaimList.DocInd'), class: 'text-left' },
          { key: 'valueCodeAmt', sortable: true, label: this.$t('PatientClaimList.ValueCodeAmt'), class: 'text-left' },
          { key: 'claimSource', sortable: true, label: this.$t('PatientClaimList.ClaimSource'), class: 'text-left' },
          { key: 'paymentPercent', sortable: true, label: this.$t('PatientClaimList.PaymentPercent'), class: 'text-left' },
          { key: 'facilityCode', sortable: true, label: this.$t('PatientClaimList.FacilityCode'), class: 'text-left' },

      ],
        ShowMessageIsEmpty:false,
        status: [], //{value:'All',name: this.$t('Shared.All')},
        ListStatus:EnumService.StatusClaimList,
        AmtBilled:0.00,
        AmtPaid:0.00,
        Balance:0.00,
        Credit:0.00,
        DateFrom:null,
        DateTo:null,
        isReadOnly: false,
        PatientTitle:{
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        dob:'',
        activitytypename:'',
        startdatetime:'',
        ageFormatted:''
      },
      ItemsHistory:[],
      ItemsDetail:[],
      parameter:{
        SearchCriteria:'',
        PageNumber : null,
        PageSize:null ,
        PatientCode:'',
        Status:"All",
      },
        OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''
        },
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
  },

  methods:{

    ChangeDropDownAttendanceOption(item){
        this.Attendance = item ? item.value : -1;
    },

    onChangeSelectDetailAll(v){
         this.DetailSelectedItem = [];
      if(v){
        this.DetailSelectedRecords = this.ItemsDetail.length;
        for(var i = 0 ; i < this.ItemsDetail.length; i++){
           this.$set(this.ItemsDetail[i], 'selected', true);
           this.DetailSelectedItem.push(this.ItemsDetail[i]);
        }

      }else{
        this.DetailSelectedRecords = 0;
        for(var j= 0 ; j < this.ItemsDetail.length; j++){
           this.$set(this.ItemsDetail[j], 'selected', false);

        }
      }
    },

    PerPageFunctionDetail(){

    },

    pageChangedDetail(){

    },

    onFilteredDetail(){

    },

    onRowSelectedDetail(){

    },

    CancelAttendanceRecordsClick(){
        this.ClaimAttendanceRecordsVisible = false;
    },

    AttendanceRecordUndoClick(){

        this.$bvModal.msgBoxConfirm('Are you sure you want to undo attendance and modify claim', {
            title: 'Undo',// this.$t('PatientClaimList.ClaimVoid'),
            okTitle: this.$t('Shared.TitleOK'),
            cancelTitle: this.$t('Shared.BtnCancel'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning',
            id:'modalPatientClaimUndo'
		}).then(value => {
          if(value){
            this.StateClick = "Attendance";
            this.showSignPasswordSuperVisor = true;
          }else{
             this.StateClick = "";
             this.showSignPasswordSuperVisor = false;
          }
        })

    },

    onRowSelectedHistory(){

    },

    onFilteredHistory(){

    },

    pageChangedHistory(){

    },

    PerPageFunctionHistory(){

    },

    getHistoryClaim(item){
        ClaimList.getHistory(item.seqNo)
            .then((response) => {
                if(response.status == '200'){
                    this.ItemsHistory = response.data;

                    this.ItemsHistory.forEach(element => {
                        element.patientClaimstatus = element.status;
                        element.sysDate = element.sysDate ? Utils.formatterDateTimeToString(element.sysDate) : null;
                    });

                    this.ClaimHistoryVisible = true;
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
    },

    getDetailClaim(seqNoList){
        ClaimList.getDetail(seqNoList)
            .then((response) => {
                if(response.status == '200'){
                    this.ItemsDetail = response.data;
                    this.ItemsDetail.forEach(element => {
                        element.transDate = element.transDate ? Utils.formatterDateToString(element.transDate) : null;
                        element.serviceDate = element.serviceDate ? Utils.formatterDateToString(element.serviceDate) : null;
                        element.timeFrom = element.timeFrom ? Utils.formatterTimeToString(element.timeFrom) : null;
                        element.timeTo = element.timeTo ? Utils.formatterTimeToString(element.timeTo) : null;
                    });

                    this.ClaimAttendanceRecordsVisible = true;
                    this.DetailSelectedRecords = 0;
                    this.UseSelectTableDetailAll = false;
                    this.ShowMessageIsEmptyDetail = this.ItemsDetail.length === 0 ? true : false;

                    this.ItemsDetailCopy = [...this.ItemsDetail];
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
    },

    UndoAttendanceClaim(){
         var List  = [];
         this.SelectedItem.forEach(element => {
           List.push(element.seqNo)
        });

        var attSelected = [];

        this.DetailSelectedItem.forEach(element => {

            const valueInt = element.unit !== null && element.unit !== undefined && element.unit !== '' && !isNaN(element.unit) ? parseInt(element.unit, 10) : 0;
            attSelected.push({
                BillSeqNo:element.billSeqNo,
                Unit:valueInt,
                RecNo:element.recNo
            });
        });

        var data = {
            AllAttendance : this.UseSelectTableDetailAll,
            AttendanceOption : this.Attendance,
            SeqNoList: List,
            AttendanceList:attSelected
        }
         ClaimList.UndoAttendance(data)
            .then((response) => {
                if(response.status == '200'){
                    this.getDetailClaim(List);
                }

               // this.ClaimAttendanceRecordsVisible = false;
            })
            .catch((error) => {
               // this.ClaimAttendanceRecordsVisible = false;
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
    },

    async GetPatientClaimChargesByDateRange(){
       let HideVoid = this.ExistHideVoid(this.status);
       let HideBalance = this.ExistHideBalance(this.status);
       await  ClaimList.ChargesByDateRange(this.$route.params.id, this.DateFrom,this.DateTo,HideVoid,HideBalance)
            .then((response) => {
                if(response.status == '200'){
                    this.AmtBilled = response.data != null ? parseFloat(response.data).toFixed(2): "0.00";
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
    },

    async GetPatientClaimPaymentsByDateRange(){
    let HideVoid = this.ExistHideVoid(this.status);
       let HideBalance = this.ExistHideBalance(this.status);
        await ClaimList.PaymentsByDateRange(this.$route.params.id, this.DateFrom,this.DateTo,HideVoid,HideBalance)
            .then((response) => {
                if(response.status == '200'){
                   this.AmtPaid = response.data != null ? parseFloat(response.data).toFixed(2): "0.00";
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
    },

    async GetPatientTotalCredit(){
        await ClaimList.TotalCredit(this.$route.params.id)
            .then((response) => {
                if(response.status == '200'){
                   this.Credit = response.data != null ? parseFloat(response.data).toFixed(2): "0.00";
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
    },

    async ComputeBalance(){
       this.GetPatientTotalCredit();
       await this.GetPatientClaimChargesByDateRange();
       await this.GetPatientClaimPaymentsByDateRange();


       this.Balance = parseFloat(this.AmtBilled - this.AmtPaid).toFixed(2);
    },

    CancelHistoryClick(){
        this.ClaimHistoryVisible = false;
    },

    OkHistoryClick(){
        this.ClaimHistoryVisible = false;
    },

    OkClick(){
        this.DoVoidClaim();
        this.WarningVisible = false;
    },
    CancelClick(){
        this.WarningVisible = false;
    },

    FindinItems(){
        this.items = this.itemsCopy;
        var arr = this.items;
        var temp = [];
        if(this.Criteria && this.Criteria?.trim() !== ""){
         arr.forEach(element => {
            if( element && element?.fullUserName?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.sysDate?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.dateFrom?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.dateTo?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.fullDoctorName?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.diagCode?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.modifier1?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.modifier2?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.modifier3?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.modifier4?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.primaryInsurance?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.primInsuranceNo?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.secondaryInsurance?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.secInsuranceNo?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.tertiaryInsurance?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.terInsuranceNo?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.charges?.toString()?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode1?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode2?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode3?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode4?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode5?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode6?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.conditionCode7?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.facilityCode?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.hcpcsCode?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.posCode?.toUpperCase()?.includes(this.Criteria?.toUpperCase())
                || element && element?.cptHcpcs?.toUpperCase()?.includes(this.Criteria?.toUpperCase())

            ){
                temp.push(element);
            }
        });
        }else{
           temp = this.itemsCopy;
        }

         this.items = temp;
         this.totalRows= this.items.length;

    },


    FindinDetailItems(){
         this.ItemsDetail = this.ItemsDetailCopy;
        var arr = this.ItemsDetail;
        var temp = [];
        if(this.DetailSearchCriteria && this.DetailSearchCriteria?.trim() !== ""){
         arr.forEach(element => {
            if( element && element?.fullUserName?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.transDate?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.serviceDate?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.courseCode?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.therapistCode?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.progCode?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.timeFrom?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.timeTo?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.unit?.toString()?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.billSeqNo?.toString()?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
                || element && element?.name?.toUpperCase()?.includes(this.DetailSearchCriteria?.toUpperCase())
            ){
                temp.push(element);
            }
        });
        }else{
           temp = this.ItemsDetailCopy;
        }

         this.ItemsDetail = temp;
         this.totalRowsDetail = this.ItemsDetail.length;
    },

    DetailClick(){
        var List  = [];
         this.SelectedItem.forEach(element => {
           List.push(element.seqNo)
        });

        if(List.length >= 1){
            this.getDetailClaim(List);
        }

    },

    HistoryClick(item){
         this.getHistoryClaim(item);
    },

     VoidClick(){
      this.$bvModal.msgBoxConfirm(this.$t('PatientClaimList.WarningClaimVoid'), {
            title: this.$t('PatientClaimList.ClaimVoid'),
            okTitle: this.$t('Shared.TitleOK'),
            cancelTitle: this.$t('Shared.BtnCancel'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning',
            id:'modalPatientClaimVoid'
		}).then(value => {
          if(value){
            this.StateClick = "Void";
            this.showSignPasswordSuperVisor = true;
          }else{
             this.StateClick = "";
             this.showSignPasswordSuperVisor = false;
          }
        })

    },

    DoVoidClaim(){
        var List = [];

        this.SelectedItem.forEach(element => {
           List.push(
            {
                RecId: element.recId,
                Charges: 0.00,
                PatientCode: element.patientCode,
                SeqNo: element.seqNo
            }
            )
        });

        var ClaimElementList = {
            ClaimList : List
        }
        ClaimList.VoidClaim(ClaimElementList)
            .then((response) => {
                if (response.status == '200') {
                    setTimeout(() =>
                        this.$bvToast.toast(this.$t('PatientClaimList.VoidMsg'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 30);
                }
            })
            .catch(error => {
                if (!error.response) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                }
                else if (error.response.status === 400) {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
                else if (error.response.status === 500) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                }
                else {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
            });
    },

    onModalPasswordResultSuperVisor(result){

      if(this.StateClick === "Void"){
         var List = [];
        this.SelectedItem.forEach(element => {
           List.push(element.issLineNo);
        });

        var IssLineRequest = {
            IssLineNoList:List
        }

        if(result.Event === 'Ok'){
            if(result.status === true) {
                ClaimList.GetClaimPayments(this.$route.params.id,IssLineRequest)
                  .then((response) => {
                    if (response.status == '200') {
                        if(response.data.length > 0){
                           const message = response.data.map(item =>
                            `A payment of <b>$${parseFloat(item.payment).toFixed(2)} </b> was previously applied to claim IssLineNo <b>${item.issLineNo}</b>.`
                                ).join('<br>') +'<br><br> Are you sure you want to void the selected claim?';

                            this.Message = message;
                            this.WarningVisible = true;
                        }else{
                           this.DoVoidClaim();
                        }
                    }

                  })
                  .catch(error => {
                    if (!error.response) {
                      this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                    }
                    else if (error.response.status === 400) {
                      this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    }
                    else if (error.response.status === 500) {
                      this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                    }
                    else {
                      this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    }
                  });
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
            }
        }
      }



      if(this.StateClick === "Attendance"){
         if(result.Event === 'Ok'){
            if(result.status === true) {
                this.UndoAttendanceClaim();
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
            }
        }
      }

        this.showSignPasswordSuperVisor = false;
    },

    AddClaim(){
        this.$router.push({ name: "claim-add", params: { id: this.$route.params.id} });
    },

    PerPageFunction(perpage){
        this.perPage = perpage;
        this.currentPage = 1;
    },

    pageChanged(page){
        this.currentPage = page;
    },

    onChangeSelectAll(v){
        this.SelectedItem = [];
      if(v){
        this.SelectedRecords = this.items.length;
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true);
           this.SelectedItem.push(this.items[i]);
        }

      }else{
        this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
           this.$set(this.items[j], 'selected', false);

        }
      }
    },

    UpdateAction(field,ResetPrintFlag,AllFlags){
        if(this.SelectedItem.length > 0){
        var List = [];
        this.SelectedItem.forEach(element => {
            let data = {};
            if(!ResetPrintFlag){
                data[field] = element[field] ? "N" : "Y";
            }else{
                data["ResetPrintFlag"] = ResetPrintFlag;
            }

            if(AllFlags){
                data.sendFalg1 = element.sendFalg1 ? "N" : "Y";
                data.sendFlag = element.sendFlag ? "N" : "Y";
            }
            data.RecId = element.recId;
            List.push(data);
        });

        var sData = {
            ClaimList:List
        }

        ClaimList.UpdateFlag(sData)
            .then((response) => {
                if(response.status == '200'){
                    this.getClaimList();
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
        }

    },

    showReport(){

    },

    onRowSelected(item){
        this.SelectedItem = item;
    },

    SearchClaim(){
        this.getClaimList();
    },

    ExistHideVoid(arr){
        for(var i = 0; i <arr.length; i++){
            if(arr[i].value === "HIDEVOID"){
                return true;
            }
        }
        return false;
    },

    ExistHideBalance(arr){
        for(var i = 0; i <arr.length; i++){
            if(arr[i].value === "HIDEZEROBALANCE"){
                return true;
            }
        }
        return false;
    },

    ExistAll(arr){
        for(var i = 0; i <arr.length; i++){
            if(arr[i].value === "All"){
                return true;
            }
        }
        return false;
    },

     PosAll(arr){
        for(var i = 0; i <arr.length; i++){
            if(arr[i].value === "All"){
                return i;
            }
        }
        return -1;
    },

    ChangeStatus(itemSelecteds){
       this.status = [];
       let arr = [];
       itemSelecteds.forEach(element => {
        arr.push(element);
       });
       this.status = arr;

       this.getClaimList();
    },

    EditClaim(row){
        this.$router.push({ name: "claim-details", params: { id: this.$route.params.id,recId:row.recId} });
    },

     rowClickHandler(item) {
        if(item.selected){
            this.$set(item, 'selected', false);
        }else{
            this.$set(item, 'selected', true);
        }
        EventBus.$emit('rowClicked', 'TableList');
     },

     rowClickHandlerDetail(item){
         if(item.selected){
            this.$set(item, 'selected', false);
        }else{
            this.$set(item, 'selected', true);
        }
        EventBus.$emit('rowClicked', 'TableDetail');
     },
    async getClaimList() {
           this.items = [];
           this.parameter.StatusList = [];

            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
            this.parameter.PageSize = null;
            this.parameter.PageNumber = null;
            this.parameter.PatientCode = this.$route.params.id;

            this.status.forEach(element => {
                this.parameter.StatusList.push(element.value);
            });

            await ClaimList.getAll(this.parameter).then((response) => {

              if(response.status == '200'){
                let headerString = response.headers["x-pagination"];
                this.Header = JSON.parse(headerString);
                this.totalRows = this.Header.TotalCount;

                this.items = response.data;

                this.UseSelectTableAll = false;
                this.SelectedRecords = 0;
                this.SelectedItem = [];

                this.ComputeBalance();
                this.items.forEach(element => {
                    element.dateFrom = element.dateFrom ? Utils.formatterDateToString(element.dateFrom) : null;
                    element.dateTo =  element.dateTo ? Utils.formatterDateToString(element.dateTo) : null;
                    element.datePaid = element.datePaid ? Utils.formatterDateToString(element.datePaid) : null;
                    element.sysDate = element.sysDate ? Utils.formatterDateToString(element.sysDate) : null;
                })
              }

              if(this.items.length === 0){
                this.ShowMessageIsEmpty = true;
              }

              this.itemsCopy = [...this.items];


            }).catch(error => {
              if (!error.response) {
                  // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
          },

    async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.$route.params.id);
      if(infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
      }
    },
  },

  created(){
    EventBus.$on("rowClicked", function (table) {

    if(table === 'TableList'){
         this.SelectedRecords = 0;
         this.SelectedItem = [];
        for(var i = 0; i < this.items.length; i++){
            if(this.items[i].selected){
                this.SelectedRecords++;
                this.SelectedItem.push(this.items[i]);
            }
        }
    }

    if(table === 'TableDetail'){
        this.DetailSelectedRecords = 0;
         this.DetailSelectedItem = [];
        for(var j = 0; j < this.ItemsDetail.length; j++){
            if(this.ItemsDetail[j].selected){
                this.DetailSelectedRecords++;
                this.DetailSelectedItem.push(this.ItemsDetail[j]);
            }
        }
    }


     }.bind(this));
  },

  async mounted(){
    this.OptionsRightMenu.visible = true;
    this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
    this.$emit("getVisibleMenu", this.OptionsRightMenu);
    this.isReadOnly = this.$store.state.isPatientClaimsEHRReadOnly;
    await this.GetPatientByCode();
    this.getClaimList();
  }

};
</script>


<style scoped>
.dynamic-width-modal .modal-dialog {
    max-width: 1200px !important;
}
</style>

